import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import Dropzone from 'react-dropzone';
import RaisedButton from 'material-ui/RaisedButton';

import { validateFilename } from '../../utils/parseFileName';
import FilenameWithIcon from '../../UI/FilenameWithIcon';

import styles from './UploadPapers.css';

class UploadPapers extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        onSave: PropTypes.func.isRequired,
    };

    state = {
        files: [],
        invalidFileNames: [],
    };

    handleDrop = files => {
        const { season } = this.props;

        this.setState({
            files: [
                ...this.state.files,
                ...files.filter(file => validateFilename(this.props.townName, file.name, season)),
            ],
            invalidFileNames: [
                ...this.state.invalidFileNames,
                ...files.map(file => file.name).filter(name => !validateFilename(this.props.townName, name, season)),
            ],
        });
    };

    handleSaveClick = () => {
        this.props.onSave(this.state.files);
    };

    render() {
        const {
            intl: { formatMessage },
        } = this.props;

        return (
            <div>
                <Dropzone
                    accept="application/pdf, application/zip, multipart/x-zip, application/octet-stream, application/zip-compressed, application/x-zip-compressed"
                    onDrop={this.handleDrop}
                    className={styles.dropzone}
                    acceptClassName={styles.activeDropzone}
                    rejectClassName={styles.rejectDropzone}
                >
                    <p>
                        <FormattedMessage id="UploadPapers.Drop here" />
                        <br />
                        <FormattedMessage id="UploadPapers.File types" />
                    </p>
                </Dropzone>
                {this.state.files.length ? (
                    <h3 className={styles.fileListHeader}>
                        <FormattedMessage id="UploadPapers.added files" />
                    </h3>
                ) : null}
                <ul className={styles.fileList}>
                    {this.state.files.map(file => file.name).map(name => (
                        <li key={name}>
                            <FilenameWithIcon filename={name} />
                        </li>
                    ))}
                </ul>
                {this.state.invalidFileNames.length ? (
                    <h3 className={styles.fileListHeader}>
                        <FormattedMessage id="UploadPapers.invalid files" />
                    </h3>
                ) : null}
                {this.state.invalidFileNames.length ? (
                    <FormattedMessage id="UploadPapers.invalid files subtitle" />
                ) : null}
                <ul className={styles.fileList}>
                    {this.state.invalidFileNames.map(name => (
                        <li key={name}>
                            <FilenameWithIcon filename={name} />
                        </li>
                    ))}
                </ul>
                <RaisedButton
                    primary
                    disabled={!this.state.files.length}
                    label={formatMessage({ id: 'UploadPapers.next' })}
                    onClick={this.handleSaveClick}
                    className={styles.button}
                />
            </div>
        );
    }
}

export default injectIntl(UploadPapers);



// WEBPACK FOOTER //
// ./src/Components/UploadPapers/UploadPapers.js